export default __webpack_public_path__ + "static/media/DONE.ed7faf7b.png";